import { z } from 'zod';

import { BankruptcyId, BankruptcyProofOfClaimId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateBankruptcyProofOfClaimSideEffectContext = BaseLoanIdSideEffect.extend({
  bankruptcyId: BankruptcyId,
  proofOfClaimId: BankruptcyProofOfClaimId,
});
export const GenerateBankruptcyProofOfClaimSideEffect = GenerateBankruptcyProofOfClaimSideEffectContext.extend({
  type: z.literal('generateBankruptcyProofOfClaim'),
});
export type GenerateBankruptcyProofOfClaimSideEffect = z.infer<typeof GenerateBankruptcyProofOfClaimSideEffect>;
